
import {css} from "lit"
export default css`

.liner {
	display: flex;
	flex-direction: column;
	gap: 2em;
}

`
